import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ConfirmOverrideDialogComponent } from '../confirm-override-dialog/confirm-override-dialog.component';
import { FlatInspectionResultDto } from '../core/api/model/flatInspectionResultDto';
import { InspectionResultType } from '../core/api/model/inspectionResultType';
import { I18NText } from '../core/api/model/i18NText';
import { NgClass } from '@angular/common';
import { DetailResultRemarkComponent } from './detail-result-remark.component';

@Component({
  selector: 'app-detail-result-button',
  templateUrl: './detail-result-button.component.html',
  styleUrls: ['./detail.component.scss'],
  imports: [NgbPopover, NgClass, TranslateDirective, DetailResultRemarkComponent, TranslatePipe],
})
export class DetailResultButtonComponent {
  private modalService = inject(NgbModal);
  private translateService = inject(TranslateService);

  @Input()
  public result!: FlatInspectionResultDto;

  @Input()
  public readonly = false;

  @Input()
  public elementName!: I18NText;

  @Input()
  public isFkp: boolean = false;

  @Input()
  public defectDescriptionSuggestions: I18NText[] | null = null;

  @Output()
  public resultChange: EventEmitter<any> = new EventEmitter();

  public resultTypes = InspectionResultType;

  public onChangeResult(): void {
    if (this.result.remark || this.result.defectDescription) {
      const modal = this.modalService.open(ConfirmOverrideDialogComponent, { size: 'sm' });
      modal.componentInstance.confirmationText = this.translateService.instant(
        'ConfirmOverrideDescription',
      );
      modal.result.then(
        () => {
          this.changeResult();
        },
        () => {},
      );
    } else {
      this.changeResult();
    }
  }

  public onChangeRemark(): void {
    this.resultChange.emit();
  }

  private changeResult(): void {
    switch (this.result.inspectionResult) {
      case InspectionResultType.NotDefined:
        // @ts-expect-error: strict null check ignored intentionally
        this.result.inspectionResult = null;
        break;
      case null:
        this.result.inspectionResult = InspectionResultType.NotApplicable;
        break;
      case InspectionResultType.NotApplicable:
        this.result.inspectionResult = InspectionResultType.Defect;
        break;
      case InspectionResultType.Defect:
        this.result.inspectionResult = InspectionResultType.NotControlled;
        break;
      case InspectionResultType.NotControlled:
        this.result.inspectionResult = InspectionResultType.NotDefined;
        break;
    }
    this.result.remark = null;
    this.result.defectDescription = null;
    this.resultChange.emit();
  }
}
